import { render, staticRenderFns } from "./CUInficationOrder.vue?vue&type=template&id=f9a7206e&scoped=true"
import script from "./CUInficationOrder.vue?vue&type=script&lang=js"
export * from "./CUInficationOrder.vue?vue&type=script&lang=js"
import style0 from "./CUInficationOrder.vue?vue&type=style&index=0&id=f9a7206e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a7206e",
  null
  
)

export default component.exports